

















import Vue from 'vue'
export default Vue.extend({
  name: 'Rating',
  props: {
    size: {
      type: Number,
      default: 20
    },
    activeColor: {
      type: String,
      default: '#F5A623'
    },
    inactiveColor: {
      type: String,
      default: '#9B9B9B'
    },
    value: {
      type: Number,
      default: 3
    },
    max: {
      type: Number,
      default: 5
    }
  },
  computed: {
    starStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    },
    range () {
      return Array(this.max).fill('').map((_, index) => index)
    }
  },
  methods: {
    indexToValue (index: number) {
      return (this.value as unknown as number) - index
    }
  }
})
